import React from 'react';
import { call, put, takeLatest, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import SVG from 'react-inlinesvg';
import { checkCircleSVG } from '../../shared/helpers/icons';
import styles from '../../shared/styles/notifications.module.scss';
import {
    GET_STORES_REQUEST,
    getStoresSuccess,
    getStoresFailure,
    SUBMIT_STORE_REQUEST,
    submitStoreSuccess,
    submitStoreFailure,
    CREATE_SINGLE_STORE_REQUEST,
    createSingleStoreSuccess,
    createSingleStoreFailure,
    CREATE_STORES_BATCH_REQUEST,
    createStoresBatchSuccess,
    createStoresBatchFailure
} from '../actions/store';
import {
    getStores,
    submitStore,
    createStore,
    updateStore,
    createStoresBatch
} from '../services/store';
import { storeSelector } from '../selectors/store';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';

export const getStoresWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);

        const response = yield call(getStores, filters, token);
        const { data, pagination } = response.data;

        yield put(getStoresSuccess(data, pagination.total));
    } catch (err) {
        yield put(getStoresFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const submitStoreWorker = function* ({ payload: { store } }) {
    try {
        const token = yield select(accessTokenSelector);

        if (!store._id) {
            yield call(createStore, store, token);
            toast.success(
                <div className={styles.customToastSuccess}>
                    <div className={styles.toastContent}>
                        <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                        Bodega creada con éxito
                    </div>
                </div>,
                {
                    className: styles.toast,
                    toastId: `user-created-${Date.now()}`
                }
            );
        } else {
            yield call(updateStore, store, token);
            toast.success(
                <div className={styles.customToastSuccess}>
                    <div className={styles.toastContent}>
                        <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                        Bodegas editadas con éxito
                    </div>
                </div>,
                {
                    className: styles.toast,
                    toastId: 'batch-store-success'
                }
            );
        }

        yield put(submitStoreSuccess(store));
    } catch (err) {
        if (err && err.response && err.response.status && err.response.status === 409) {
            yield put(showGlobalError(true, 409, 'user_already_exist'));
        } else {
            yield put(showGlobalError(true, err));
        }
        yield put(submitStoreFailure(err));
    }
};

const createStoresBatchWorker = function* ({ payload: { stores } }) {
    try {
        const token = yield select(accessTokenSelector);
        yield call(createStoresBatch, stores, token);
        toast.success(
            <div className={styles.customToastSuccess}>
                <div className={styles.toastContent}>
                    <SVG src={checkCircleSVG} className={styles.toastIconSuccess} />
                   Bodegas creadas con éxito
                </div>
            </div>,
            {
                className: styles.toast,
                toastId: `user-created-${Date.now()}`
            }
        );
        yield put(createStoresBatchSuccess());
    } catch (err) {
        yield put(createStoresBatchFailure(err));
        yield put(showGlobalError(true, err));
    }
};


const createSingleStoreWorker = function* ({ payload }) {
    try {
        const token = yield select(accessTokenSelector);
        const storeData = payload.store || payload;
        yield call(createStore, storeData, token);
        yield put(createSingleStoreSuccess());
        yield put(getStores());
    } catch (error) {
        yield put(createSingleStoreFailure(error));
        yield put(showGlobalError(true, error.response?.status, 'error_creating_store'));
    }
}

export default [
    takeLatest(GET_STORES_REQUEST, getStoresWorker),
    takeLatest(SUBMIT_STORE_REQUEST, submitStoreWorker),
    takeLatest(CREATE_SINGLE_STORE_REQUEST, createSingleStoreWorker),
    takeLatest(CREATE_STORES_BATCH_REQUEST, createStoresBatchWorker)
]
